import React from "react";

import { CONTENT_ICON_BY_NAME, CONTENT_TYPE_ICONS } from "./contentTypeIcons";
import { CONTENT_TYPE, EXTERNAL_SERVICE_TYPE } from "./Type";
import arte from "../../resources/external_arte.png";
import dailymotion from "../../resources/external_dailymotion.png";
import facebook from "../../resources/external_facebook.png";
import francetv from "../../resources/external_francetv.png";
import vimeo from "../../resources/external_vimeo.png";
import youtube from "../../resources/external_youtube.png";
import { CELL_ICON_CLASS } from "../dataTable/dataTableStyles";

import type { LucideIcon } from "lucide-react";
import type { JSX } from "react";

import type { ContentListRow } from "./tableParams/contentColumns.types";

interface ContentTypeIconProps {
  content: Omit<ContentListRow, "external_stream"> & {
    external_stream?: { player_code?: string | null } | null;
  };
}

const SERVICE_ICONS: Record<string, string | undefined> = {
  [EXTERNAL_SERVICE_TYPE.DAILYMOTION]: dailymotion,
  [EXTERNAL_SERVICE_TYPE.ARTE]: arte,
  [EXTERNAL_SERVICE_TYPE.FACEBOOK]: facebook,
  [EXTERNAL_SERVICE_TYPE.VIMEO]: vimeo,
  [EXTERNAL_SERVICE_TYPE.FRANCETV]: francetv,
};

const ICON_BY_NAME: Record<string, LucideIcon | undefined> =
  CONTENT_ICON_BY_NAME;

function ContentTypeIcon({ content }: ContentTypeIconProps): JSX.Element {
  const { type, content_type: contentType } = content;
  const stream = content.external_stream;

  if (type === CONTENT_TYPE.MASTER) {
    return (
      <CONTENT_TYPE_ICONS.master
        aria-hidden="true"
        className={CELL_ICON_CLASS}
      />
    );
  }

  if (type === CONTENT_TYPE.EXTERNAL && stream?.player_code) {
    const service = stream.player_code.split("|")[0] ?? "";
    const icon = SERVICE_ICONS[service] ?? youtube;

    return (
      <div
        className="external-icon"
        style={{
          backgroundImage: `url(${icon})`,
          width: "20px",
          height: "20px",
          backgroundSize: "contain",
        }}
      />
    );
  }

  const TypeIcon = ICON_BY_NAME[contentType] ?? CONTENT_TYPE_ICONS.video;
  return <TypeIcon aria-hidden="true" className={CELL_ICON_CLASS} />;
}

export default ContentTypeIcon;
